import CustomTextarea from "../../../components/Textarea/index.js";
import { BusinessContext } from "../../../entities/useCaseChat/UseCase";
import type { ChangeEvent } from 'react';
import { CtxGrid, CtxField } from "../../../components/UseCaseContextField/index.js";

interface BusinessContextFormProps {
    formValues: BusinessContext;
    onInputChange: (field: keyof BusinessContext, value: string) => void;
    viewOnly?: boolean
}

const BusinessContextForm: React.FC<BusinessContextFormProps> = ({
    formValues,
    onInputChange,
    viewOnly = true
}) => {
    if (viewOnly) {
        return (
            <CtxGrid>
                <CtxField label="Business Criticality" value={formValues.businessCriticality} placeholder="No business criticality provided" />
                <CtxField label="Applicable Sectors" value={formValues.applicableSectors} placeholder="No applicable sectors provided" />
                <CtxField label="Regions of Deployment" value={formValues.deploymentRegions} placeholder="No deployment regions provided" />
                <CtxField label="Maintained By" value={formValues.maintenanceApproach} placeholder="No maintenance approach provided" />
                <CtxField label="Impacted Nationalities" value={formValues.impactedNationalities} placeholder="No impacted nationalities provided" />
                <CtxField label="Human in the Loop" value={formValues.humanInTheLoop} placeholder="No human in the loop provided" />
            </CtxGrid>
        );
    }
    return (
        <div className="space-y-6 pb-2">
            <CustomTextarea
                variant="plain"
                label="Business Criticality"
                value={formValues.businessCriticality}
                onChange={(e: string | React.ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("businessCriticality", e)
                    } else {
                        onInputChange("businessCriticality", e.target.value)
                    }
                }}
                placeholder="Enter business criticality"
            />
            <CustomTextarea
                variant="plain"
                label="Applicable Sectors"
                value={formValues.applicableSectors}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("applicableSectors", e)
                    } else {
                        onInputChange("applicableSectors", e.target.value)
                    }
                }}
                placeholder="Enter applicable sectors"
            />
            <CustomTextarea
                variant="plain"
                label="Regions of Deployment"
                value={formValues.deploymentRegions}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("deploymentRegions", e)
                    } else {
                        onInputChange("deploymentRegions", e.target.value)
                    }
                }}
                placeholder="Enter deployment regions"
            />

            <CustomTextarea
                variant="plain"
                label="Maintained By:"
                value={formValues.maintenanceApproach}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("maintenanceApproach", e)
                    } else {
                        onInputChange("maintenanceApproach", e.target.value)
                    }
                }}
                placeholder="Enter maintenance approach"
            />
            <CustomTextarea
                variant="plain"
                label="Impacted Nationalities"
                value={formValues.impactedNationalities}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("impactedNationalities", e)
                    } else {
                        onInputChange("impactedNationalities", e.target.value)
                    }
                }}
                placeholder="Enter impacted nationalities"
            />
            <CustomTextarea
                variant="plain"
                label="Human in the Loop"
                value={formValues.humanInTheLoop}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("humanInTheLoop", e)
                    } else {
                        onInputChange("humanInTheLoop", e.target.value)
                    }
                }}
                placeholder="Enter human in the loop"
            />
        </div>
    )
}
export default BusinessContextForm;



